<template>
  <section :id="`comp_id_${compProps.elementId}`">
    <div class="element-floor-wrapper swiper-container" :style="`background-color: ${backgroundColor}; padding-left: ${floorMarginLeft}; padding-right: ${floorMarginRight};`">
      <div v-if="needShow" v-show="isShowPadding" class="element-padding" :style="`height: ${wrapperPadding}px`"></div>
      <div class="element-floor swiper-wrapper" :style="`height: ${floorHeight};`">
        <div
          @click="jumpTo(`comp_id_${item.elementId}`, index, item.elementId, item.name)"
          data-actionid="5"
          :data-itemtext="item.name"
          v-for="(item, index) in items"
          :data-id="`comp_id_${item.elementId}`"
          :key="index"
          class="swiper-slide">
          <img class="floor-img"
            :src="picHost+(currentId === `comp_id_${item.elementId}` ? item.selectionIcon : item.defaultIcon)"
            :style="`background-color: ${currentId !== `comp_id_${item.elementId}` ? backgroundColor : activeColor}; margin-right: ${index === items.length-1 ? floorMarginRight : floorSpacing};`">
        </div>
      </div>
    </div>
  </section>
</template>
<script>
/**
 * 这个组件真的不知道该咋加注释，就是一个UI交互组件，点哪跳哪。
 */
import { throttle } from '@/utils'
import { Sniff } from '@/utils/q_sniff'
import sendLog from '@/utils/q_log'
const DEFAULT_HEIGHT = 40
export default {
  data() {
    return {
      currentId: '',
      wrapperPadding: 0,
      isShowPadding: false,
      needShow: false,
      ratio: document.body.clientWidth / 375
    }
  },
  mounted() {
    const { hastitle } = this.$route.query
    // eslint-disable-next-line
    if (hastitle == 1) {
      this.needShow = true
    // eslint-disable-next-line
    } else if (hastitle == 2) {
      this.needShow = false
    } else if (this.platform === 6) {
      this.needShow = true
    }
    this.wrapperPadding = Sniff.statusBarH
    // 楼层曝光埋点
    const nameList = []
    this.compProps.mate.items.forEach((item) => {
      nameList.push(item.name)
    })
    // eslint-disable-next-line
    this.swiper = new Swiper('.element-floor-wrapper', {
      slidesPerView: 'auto',
      freeMode: true,
      initialSlide: 0
    })
    window._fas && window._fas.setCustomTrack({
      eventname: 'C_HOME_CMS_TRAVELAROUND_FLOOR_NAVIGATION_EXPOSURE',
      ext: {
        value: nameList,
        rank_list_id: this.$root.promotionId,
        rank_list_name: this.$root.htmlTitle
      }
    })
  },
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    compIndex: {
      type: String,
      default: function() {
        return ''
      }
    },
    isTujiaHarmony: {
      type: Boolean,
      default: false
    },
    tujiaHarmonyStatusBarHeight: {
      type: Number,
      default: 0
    }
  },
  computed: {
    items() {
      if (this.compProps.mate) {
        return this.compProps.mate.items
      } else {
        return []
      }
    },
    backgroundColor() {
      return this.compProps.mate && this.compProps.mate.privateProps && this.compProps.mate.privateProps.backgroundColor
    },
    activeColor() {
      return this.compProps.mate && this.compProps.mate.privateProps && this.compProps.mate.privateProps.activeColor
    },
    floorHeight() {
      return `${(this.compProps?.mate?.privateProps?.floorHeight || 50) * this.ratio}px`
    },
    floorMarginLeft() {
      return `${(this.compProps?.mate?.privateProps?.floorMarginLeft || 0) * this.ratio}px`
    },
    floorMarginRight() {
      return `${(this.compProps?.mate?.privateProps?.floorMarginRight || 0) * this.ratio}px`
    },
    floorSpacing() {
      return `${(this.compProps?.mate?.privateProps?.floorSpacing || 0) * this.ratio}px`
    }
  },
  created() {
    this.scrollHandle = throttle(16, this.scrollHandle).bind(this)
    window.addEventListener('scroll', this.scrollHandle, false)
    window.addEventListener('resize', this.changeRatio, false)
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollHandle, false)
    window.removeEventListener('resize', this.changeRatio, false)
  },
  methods: {
    changeRatio() {
      this.ratio = document.body.clientWidth / 375
    },
    /**
     * 跳到指定用户点击的位置
     */
    jumpTo(eleId, idx, floorId, floorName) {
      const { isTujiaAppEnv } = this.platformEnv
      if (process.env.VUE_APP_LOCAL === 'Q') {
        const logParam = {
          actPos: `${this.compIndex}_${idx}`,
          actPage: `cms_${this.$root.promotionId}`,
          actText: `cms_${this.$root.promotionId}_floor`
        }
        sendLog(logParam)
      }
      const self = document.getElementById(eleId)
      if (self) {
        this.currentId = eleId
        const floor = document.querySelector('.element-floor')
        this.height = floor.getBoundingClientRect().height
        if (isTujiaAppEnv) {
          window.scrollTo(0, self.offsetTop - this.height - DEFAULT_HEIGHT)
        } else {
          window.scrollTo(0, self.offsetTop - this.height)
        }
      }

      this.swiper.slideTo(idx)
      // 楼层点击埋点
      window._fas && window._fas.setCustomTrack({
        eventname: 'C_HOME_CMS_TRAVELAROUND_FLOOR_NAVIGATION_CLICK',
        ext: {
          floorid: floorId,
          floor_text: floorName,
          position: idx,
          rank_list_id: this.$root.promotionId,
          rank_list_name: this.$root.htmlTitle
        }
      })
    },
    /**
     * 滚动回调
     */
    scrollHandle() {
      // 因为该组件会通过滚动引起组件变化，所以一定要等变化结束后再进行计算。以获取最新的结果
      // 通过setTimeout将该处理加入到消息队列的最末尾以达到这个目的
      const { isTujiaAppEnv } = this.platformEnv
      setTimeout(() => {
        const t = document.documentElement.scrollTop || document.body.scrollTop
        const self = document.querySelector(`#comp_id_${this.compProps.elementId}`)
        const floor = document.querySelector('.element-floor-wrapper')
        this.height = floor.getBoundingClientRect().height
        const harmonyWithoutAdrOffset = Sniff.isHarmonyWithoutAdr ? Sniff.immersiveOffset + DEFAULT_HEIGHT : this.isTujiaHarmony ? this.tujiaHarmonyStatusBarHeight + DEFAULT_HEIGHT : 0
        this.offsetTop = self.clientTop + self.offsetTop - harmonyWithoutAdrOffset

        let currentId = ''
        let currentIndex = 0
        this.items.forEach((item, index) => {
          const ele = document.getElementById(`comp_id_${item.elementId}`)
          if (ele) {
            const rect = ele.getBoundingClientRect()
            // 不能算太准，否则效果不好。
            // if (Math.floor(0 + this.height + 20) >= Math.floor(rect.top) && Math.floor(0 + this.height - 20) <= Math.floor(rect.bottom)) {
            let FloorHeight = this.height
            if (isTujiaAppEnv) {
              FloorHeight = FloorHeight + DEFAULT_HEIGHT
            }
            if (Math.floor(0 + FloorHeight + 5) >= Math.floor(rect.top)) {
              currentId = `comp_id_${item.elementId}`
              currentIndex = index
            }
          }
        })
        if (currentId && this.currentId !== currentId) {
          // const floorItem = document.querySelector(`div[data-id=${currentId}]`)
          // if (floorItem.offsetLeft + floorItem.clientWidth > floor.scrollLeft + document.body.clientWidth) {
          //   floor.scrollLeft = floorItem.offsetLeft + floorItem.clientWidth - document.body.clientWidth
          // } else if (floorItem.offsetLeft < floor.scrollLeft) {
          //   floor.scrollLeft = floorItem.offsetLeft
          // }
          this.swiper.slideTo(currentIndex)
        }
        this.currentId = currentId
        this.currentIdx = currentIndex

        if (t > this.offsetTop || this.currentId) {
          self.style.height = this.height + 'px'
          if (isTujiaAppEnv) {
            self.childNodes[0].classList.add('tj-wrap-fixed')
            if (this.isTujiaHarmony) {
              self.childNodes[0].style.top = this.tujiaHarmonyStatusBarHeight + DEFAULT_HEIGHT + 'px'
            }
          } else if (Sniff.isHarmonyWithoutAdr) {
            self.childNodes[0].style.position = 'fixed'
            self.childNodes[0].style.top = Sniff.immersiveOffset + DEFAULT_HEIGHT + 'px'
            self.childNodes[0].style.zIndex = '10'
          } else {
            self.childNodes[0].classList.add('wrap-fixed')
          }
          this.isShowPadding = true
        } else {
          if (isTujiaAppEnv) {
            self.childNodes[0].classList.remove('tj-wrap-fixed')
            if (this.isTujiaHarmony) {
              self.childNodes[0].style.position = ''
              self.childNodes[0].style.top = ''
              self.childNodes[0].style.zIndex = ''
            }
          } else if (Sniff.isHarmonyWithoutAdr) {
            self.childNodes[0].style.position = ''
            self.childNodes[0].style.top = ''
            self.childNodes[0].style.zIndex = ''
          } else {
            self.childNodes[0].classList.remove('wrap-fixed')
          }
          this.isShowPadding = false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.element-floor {
  div {
    width: auto;
    height: 100%;
  }
}

.element-padding {
  background: #fff;
}
.tj-wrap-fixed {
  position: fixed;
  top: 40px;
  z-index: 10;
}
.wrap-fixed {
  position: fixed;
  top: 0;
  z-index: 10;
}
.floor-img {
  height: 100%;
}
</style>
